/**
 * Copy, share and open a published site (web): the clipboard,
 * `navigator.share` where the browser has it (else the link is copied), and
 * a new tab without an opener. `site-share.ts` is the native twin.
 */
import * as Clipboard from 'expo-clipboard';

export async function copySiteLink(url: string): Promise<boolean> {
  try {
    await Clipboard.setStringAsync(url);
    return true;
  } catch {
    return false;
  }
}

export function canShareSiteLink(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function shareSiteLink(url: string, title: string): Promise<'shared' | 'copied' | 'failed'> {
  if (canShareSiteLink()) {
    try {
      await navigator.share({ url, title });
      return 'shared';
    } catch (error) {
      // Closing the share sheet is not a failure.
      if (error instanceof Error && error.name === 'AbortError') return 'shared';
    }
  }
  return (await copySiteLink(url)) ? 'copied' : 'failed';
}

export async function openSite(url: string): Promise<void> {
  if (typeof window === 'undefined') return;
  window.open(url, '_blank', 'noopener,noreferrer');
}
